import React, { useContext, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import styles from "./Branches.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { NavigationContext } from "../../../App";

const Branches = ({ data }) => {
  const swiperRef = useRef(null);
  console.log("brancg data rrr", data);
  const navigate = useNavigate();
  const location = useLocation();
  const { setIsBackNavigation } = useContext(NavigationContext);
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
    ? "online-consultation"
    : "home";

  return (
    <div className={styles.outerDiv}>
      <div className={styles.outersubtitle}>
        <h2 className={`${styles.subtitle} bg-primary-200 primary-300`}>
          {data?.subTitle}
        </h2>
      </div>
      {data?.showTitle && (
        <h1
          className={styles.title}
          dangerouslySetInnerHTML={{ __html: data?.title }}
        ></h1>
      )}
      <div className={`${styles.div1} bg-primary-500`}>
        <img
          src="/img/icons/branch-bottom-left-pattern.svg"
          className={styles.pattern1}
        />
        <img
          src="/img/icons/branch-bottom-right-pattern.svg"
          className={styles.pattern2}
        />
        <img
          src="/img/icons/branch-top-right-pattern.svg"
          className={styles.pattern3}
        />
        <Swiper
          modules={[Autoplay, Navigation]}
          spaceBetween={30}
          slidesPerView={1}
          autoplay={{ delay: 5000, disableOnInteraction: false }}
          loop={true}
          navigation={{
            prevEl: `.${styles.leftArrow}`,
            nextEl: `.${styles.rightArrow}`,
          }}
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          className={styles.carousel}
        >
          {data?.listingItems?.map((branch, index) => (
            <SwiperSlide key={index}>
              <div className={styles.carouselContent}>
                <div className={styles.leftSection}>
                  <div className={styles.div2}>
                    <img
                      src={branch?.images[0]?.url}
                      alt={branch?.images[0]?.imageTag}
                      className={styles.branchImage}
                    />
                    <div className={`${styles.div3}`}>
                      <button
                        className={`${styles.contactButton} bg-primary-500`}
                      >
                        Contact Info
                      </button>
                      <div
                        className={styles.direction}
                        onClick={() => {
                          const url = `https://www.google.com/maps?q=${encodeURIComponent(
                            branch?.name,
                            branch?.address
                          )}`;
                          window.open(url, "_blank");
                          //   window.open(
                          //     `https://www.google.com/maps?q=${branch?.coordinates?.latitude},${branch?.coordinates?.longitude}`,
                          //     "_blank"
                          //   );
                        }}
                      >
                        <span>GET DIRECTION</span>
                        <img
                          src="/img/right-arrow.svg"
                          alt="Arrow"
                          className={styles.arrowImage}
                        />
                      </div>
                    </div>
                    <div className={styles.features}>
                      <div className={styles.featureItem}>
                        <img
                          src="/img/icons/location-black.svg"
                          alt="Location Icon"
                          className={styles.featureIcon}
                        />
                        <span>{branch?.location}</span>
                      </div>
                      <a
                        href={`mailto:${branch?.email}`}
                        className={styles.featureLink}
                      >
                        <div className={styles.featureItem}>
                          <img
                            src="/img/icons/email-black.svg"
                            alt="Email Icon"
                            className={styles.featureIcon}
                          />

                          <span>{branch?.email}</span>
                        </div>
                      </a>
                      <a
                        href={`tel:${branch?.phoneNumber}`}
                        className={styles.featureLink}
                      >
                        <div className={styles.featureItem}>
                          <img
                            src="/img/icons/call-black.svg"
                            alt="Call Icon"
                            className={styles.featureIcon}
                          />

                          <span>{branch?.phoneNumber}</span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className={styles.rightSection}>
                  <h2 className={`${styles.rightTitle} primary-500`}>
                    {branch?.name}
                  </h2>
                  <p
                    className={styles.rightDescription}
                    dangerouslySetInnerHTML={{ __html: branch?.description }}
                  ></p>
                  <button
                    className={`${styles.exploreButton} primary-500`}
                    onClick={() => {
                      const yPos = window.scrollY;
                      sessionStorage.setItem("scrollTargetY", yPos.toString());
                      sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
                      setIsBackNavigation(true);
                      navigate(`/branch/${branch.slug}`);
                    }}
                  >
                    Explore Now
                  </button>
                  <div className={styles.navigation}>
                    <img
                      src="/img/left-arrow.svg"
                      alt="Previous"
                      className={`${styles.leftArrow} ${styles.arrow}`}
                      onClick={() => swiperRef.current?.slidePrev()}
                    />
                    <img
                      src="/img/left-arrow.svg"
                      alt="Next"
                      className={`${styles.rightArrow} ${styles.arrow}`}
                      onClick={() => swiperRef.current?.slideNext()}
                    />
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Branches;
